import { SimpleChoiceType } from '@/features/ChoicesLists/Simple/types';
import isObject from 'lodash/isObject';

export const getChoiceValues = (choicesEnum: any) =>
  (isObject(choicesEnum)
    ? Object.values(choicesEnum)
    : []) as SimpleChoiceType[];
